import { Box, Link, Typography, useMediaQuery } from "@mui/material"

const SingleCatalogColumns = () => {
    const isMobile = useMediaQuery("(max-width:600px)")

    return [
    {
        field: "manufacturerPartNumber",
        headerName: "Manufacturer Part #",
        flex: 1,
        renderCell: ({ row: { _id, manufacturerPartNumber } }) => (
            <Link
                className="hive-grid-link-cell"
                href={`/products/${_id}`}
                underline="none"
                sx={{ color: "rgb(70 128 255)", fontWeight: 500 }}
            >
                {manufacturerPartNumber}
            </Link>
        )
    },
    ...(isMobile ? [] : [
    {
        field: "category",
        headerName: "Category",
        flex: 1,
    },
    {
        field: "productCode",
        headerName: "Product Code",
        flex: 1,
    },
    {
        field: "active",
        headerName: "Status",
        flex: 0.8,
        renderCell: ({ row: { active } }) => (
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    height: "100%",
                }}
            >
                <Typography sx={{ color: active === false ? "#c53939" : "#2e7d32", fontWeight: 600, fontSize: "0.875rem" }}>
                    {active === false ? "Inactive" : "Active"}
                </Typography>
            </Box>
        )
    },
    {
        field: "description",
        headerName: "Description",
        flex: 3,
    },
    {
        field: "cost",
        headerName: "Unit Cost",
        flex: 0,
        renderCell: ({ row: { cost } }) => (
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    height: "100%",
                }}
            >
                <Typography className="hive-single-catalog-cost" sx={{ color: "#592e7dff", fontWeight: 500, fontSize: "0.875rem" }}>
                    {cost
                        ? new Intl.NumberFormat("en-US", {
                            style: "currency",
                            currency: "USD",
                        }).format(cost)
                        : "$0.00"}
                </Typography>
            </Box>
        )
    },
    ]),
    {
        field: "price",
        headerName: "Unit Price",
        flex: 0,
        renderCell: ({ row: { price } }) => (
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    height: "100%",
                }}
            >
                <Typography className="hive-base-single-catalog-price" sx={{ color: "#2e7d32", fontWeight: 500, fontSize: "0.875rem" }}>
                    {price
                        ? new Intl.NumberFormat("en-US", {
                            style: "currency",
                            currency: "USD",
                        }).format(price)
                        : "$0.00"}
                </Typography>
            </Box>
        )
    },
    ...(isMobile ? [] : [
    {
        field: "createdBy",
        headerName: "Created By",
        flex: 1,
    },
    {
        field: "createdAt",
        headerName: "Date Created",
        flex: 1,
        renderCell: ({ row: { createdAt } }) => {
            if (!createdAt) return ""
            const date = typeof createdAt === "string" ? new Date(createdAt) : createdAt
            return date.toISOString().split("T")[0]
        },
    },
    {
        field: "updatedAt",
        headerName: "Last Updated",
        flex: 1,
        renderCell: ({ row: { updatedAt } }) => {
            if (!updatedAt) return ""
            const date = typeof updatedAt === "string" ? new Date(updatedAt) : updatedAt
            return date.toISOString().split("T")[0]
        },
    },
    {
        field: "lastModifiedBy",
        headerName: "Last Updated By",
        flex: 1,
    },
    ]),
]
}

export default SingleCatalogColumns
